import React from 'react';
import ProjectWrapper from './ProjectWrapper';

// PHAÍNŌ
export const PhainoWrapper = () => (
  <ProjectWrapper
    wrapperClass="wrapper-phaino"
    position={{ left: 93, top: 40, zIndex: 'auto' }}
    dimensions={{ width: 336, height: 744 }}
    hoverConfig={{
      image1: '/media/MinPhainoOne.png',
      image2: '/media/MinPhainoTwo.png',
      displacementImage: '/media/1.png',
      intensity: 0.2
    }}
    textConfig={{
      title: 'PHAÍNŌ',
      texts: [
        'Installation immersive, spatialisation en octophonie,',
        'performance, temps réel, composition interactive',
        '2026'
      ],
      blocClass: 'text-bloc-phaino',
      titleClass: 'title-phaino',
      textClass: 'text-phaino',
      blocStyle: { marginTop: '200px', marginLeft: '0' },
      titleStyle: { marginBottom: '25px', marginLeft: '-30px', marginTop: '-88px' },
      textStyle: { marginLeft: '55px' },
      textWidth: '210px',
      textAlign: 'end'
    }}
    linkTo="/phaino"
  />
);

// NOISE — RUMEURS ET ANOMALIES
export const NoiseWrapper = () => (
  <ProjectWrapper
    wrapperClass="wrapper-noise"
    position={{ left: 371, top: 56, zIndex: 'auto' }}
    dimensions={{ width: 324, height: 624 }}
    hoverConfig={{
      image1: '/media/MinNoiseOne.png',
      image2: '/media/MinNoiseTwo.png',
      displacementImage: '/media/11.png',
      intensity: 0.5
    }}
    textConfig={{
      title: 'NOISE',
      texts: [
        ' - rumeurs et anomalies',
        'Installation, octophonie,',
        'composition sonore contributive',
        '2026'
      ],
      blocClass: 'text-bloc-noise',
      titleClass: 'title-noise',
      textClass: 'text-noise',
      blocStyle: { marginTop: '0px', marginLeft: '30px' },
      titleStyle: { marginBottom: '240px', marginLeft: '110px', marginTop: '168px' },
      textStyle: { marginLeft: '15px'},
      textWeight: 'bold',
      textColor: 'black',
      textWidth: '220px',
    }}
    linkTo="/noise"
  />
);

// SILOPORTEM — WEAVING THE HEART MACHINE
export const SiloportemWrapper = () => (
  <ProjectWrapper
    wrapperClass="wrapper-siloportem"
    position={{ left: 652, top: 20, zIndex: 'auto' }}
    dimensions={{ width: 320, height: 660 }}
    hoverConfig={{
      image1: '/media/MinSiloportemOne.png',
      image2: '/media/MinSiloportemTwo.png',
      displacementImage: '/media/10.png',
      intensity: 0.4
    }}
    textConfig={{
      title: 'SILOPORTEM',
      texts: [
        ' - Weaving the Heart Machine',
        'Installation, spatialisation en octophonie, VJing',
        '2026'
      ],
      blocClass: 'text-bloc-siloportem',
      titleClass: 'title-siloportem',
      textClass: 'text-siloportem',
      blocStyle: { marginTop: '500px', marginLeft: '35px' },
      titleStyle: { marginBottom: '10px', marginLeft: '10px', marginTop: '20px' },
      textStyle: { marginLeft: '30px' },
      textWidth: '260px'
    }}
    linkTo="/siloportem"
  />
);

// ANHYDRAN
export const AnhydranWrapper = () => (
  <ProjectWrapper
    wrapperClass="wrapper1"
    position={{ left: 960, top: 0, zIndex: 'auto' }}
    dimensions={{ width: 256.18, height: 697.85 }}
    hoverConfig={{
      image1: '/media/MinAnhydranOne.png',
      image2: '/media/MinAnhydranTwo.png',
      displacementImage: '/media/2.png',
      intensity: 0.3
    }}
    textConfig={{
      title: 'AN·HYDRA·N',
      texts: [
        'Installation immersive, spatialisation en octophonie,',
        'performance, temps réel',
        '2023 - 2026'
      ],
      blocClass: 'text-bloc-anhydran',
      titleClass: 'title-anhydran',
      textClass: 'text-anhydran',
      blocStyle: { marginTop: '200px', marginLeft: '0' },
      titleStyle: { marginBottom: '25px', marginLeft: '-0px', marginTop: '-88px' },
      textStyle: { marginLeft: '30px' },
      textWidth: '200px'
    }}
    linkTo="/anhydran"
  />
);

// PHONEMES #2
export const Phonemes2Wrapper = () => (
  <ProjectWrapper
    wrapperClass="wrapper2"
    position={{ left: 1248, top: 175, zIndex: 'auto' }}
    dimensions={{ width: 289.14, height: 532.15 }}
    hoverConfig={{
      image1: '/media/MinPhonemesTwoOne.png',
      image2: '/media/MinPhonemesTwoTwo.png',
      displacementImage: '/media/13.png',
      intensity: 0.2
    }}
    textConfig={{
      title: 'PHONÈMES #2',
      texts: [
        'Installation immersive, spatialisation en 5.1',
        '2021 - 2022'
      ],
      blocClass: 'text-bloc-phonemes2',
      titleClass: 'title-phonemes2',
      textClass: 'text-phonemes2',
      blocStyle: { marginTop: '70px', marginLeft: '0' },
      titleStyle: { marginBottom: '250px', marginLeft: '60px', marginTop: '0px' },
      textStyle: { marginLeft: '5px' },
      textWidth: '250px',
      textAlign: 'end'
    }}
    linkTo="/phonemes2"
  />
);

// PHONEMES
export const Phonemes1Wrapper = () => (
  <ProjectWrapper
    wrapperClass="wrapper3"
    position={{ left: 1568, top: 50, zIndex: 1 }}
    dimensions={{ width: 314.21, height: 444.92 }}
    hoverConfig={{
      image1: '/media/MinPhonemesOneTwo.png',
      image2: '/media/MinPhonemesOneOne.png',
      displacementImage: '/media/1.png',
      intensity: 1.8
    }}
    textConfig={{
      title: 'PHONÈMES',
      texts: [
        'Installation immersive, spatialisation en octophonie',
        '2020 - 2022'
      ],
      blocClass: 'text-bloc-phonemes1',
      titleClass: 'title-phonemes1',
      textClass: 'text-phonemes1',
      blocStyle: { marginTop: '100px', marginLeft: '0' },
      titleStyle: { marginBottom: '250px', marginLeft: '-40px', marginTop: '-88px' },
      textStyle: { marginLeft: '30px' },
      textWidth: '230px'
    }}
    linkTo="/phonemes1"
  />
);

// TRANSMUTATION
export const TransmutationWrapper = () => (
  <ProjectWrapper
    wrapperClass="wrapper4"
    position={{ left: 1792, top: 100, zIndex: 'auto' }}
    dimensions={{ width: 371.90, height: 624.75 }}
    hoverConfig={{
      image1: '/media/MinTransmutationOne.png',
      image2: '/media/MinTransmutationTwo.png',
      displacementImage: '/media/10.png',
      intensity: 1
    }}
    textConfig={{
      title: 'TRANSMUTATION',
      texts: [
        'Installation, quadriphonie',
        '2019 - 2023'
      ],
      blocClass: 'text-bloc-transmutation',
      titleClass: 'title-transmutation',
      textClass: 'text-transmutation',
      blocStyle: { marginTop: '420px', marginLeft: '0' },
      titleStyle: { marginBottom: '0px', marginLeft: '20px', marginTop: '20px' },
      textStyle: { marginLeft: '70px' },
      textWeight: 'bold',
      textColor: 'black',
      textWidth: '200px'
    }}
    linkTo="/transmutation"
  />
);

// FLOTS
export const FlotsWrapper = () => (
  <ProjectWrapper
    wrapperClass="wrapper5"
    position={{ left: 2194, top: 10, zIndex: 'auto' }}
    dimensions={{ width: 280.86, height: 567.8 }}
    hoverConfig={{
      image1: '/media/MinFlotsOne.png',
      image2: '/media/MinFlotsTwo.png',
      displacementImage: '/media/11.png',
      intensity: 0.8
    }}
    textConfig={{
      title: 'FLOTS',
      texts: [
        'Installation',
        '2019 - 2021'
      ],
      blocClass: 'text-bloc-flots',
      titleClass: 'title-flots',
      textClass: 'text-flots',
      blocStyle: { marginTop: '40px', marginLeft: '0' },
      titleStyle: { marginBottom: '20px', marginLeft: '160px', marginTop: '0px' },
      textStyle: { marginLeft: '20px' },
      textWeight: 'bold',
      textColor: 'black',
      textWidth: '200px'
    }}
    linkTo="/flots"
  />
);

// TRANSCENDANCE
export const TranscendanceWrapper = () => (
  <ProjectWrapper
    wrapperClass="wrapper6"
    position={{ left: 2505, top: 55, zIndex: 'auto' }}
    dimensions={{ width: 343.65, height: 621.35 }}
    hoverConfig={{
      image1: '/media/MinTranscendanceOne.png',
      image2: '/media/MinTranscendanceTwo.png',
      displacementImage: '/media/10.png',
      intensity: 0.8
    }}
    textConfig={{
      title: 'TRANSCENDANCE',
      texts: [
        'Modélisation',
        '2019 - 2022'
      ],
      blocClass: 'text-bloc-transcendance',
      titleClass: 'title-transcendance',
      textClass: 'text-transcendance',
      blocStyle: { marginTop: '470px', marginLeft: '0' },
      titleStyle: { marginBottom: '20px', marginLeft: '0px', marginTop: '20px' },
      textStyle: { marginLeft: '50px' },
      textWeight: 'bold',
      textColor: 'black',
      textWidth: '200px'
    }}
    linkTo="/transcendance"
  />
);

// T.I.N.A.
export const TinaWrapper = () => (
  <ProjectWrapper
    wrapperClass="wrapper7"
    position={{ left: 2877, top: 300, zIndex: 1 }}
    dimensions={{ width: 361.69, height: 432.65 }}
    hoverConfig={{
      image1: '/media/MinTINAOne.png',
      image2: '/media/MinTINATwo.png',
      displacementImage: '/media/1.png',
      intensity: 2
    }}
    textConfig={{
      title: 'T.I.N.A.',
      texts: [
        'Installation, performance',
        '2018 - 2019'
      ],
      blocClass: 'text-bloc-tina',
      titleClass: 'title-tina',
      textClass: 'text-tina',
      blocStyle: { marginTop: '45px', marginLeft: '0' },
      titleStyle: { marginBottom: '20px', marginLeft: '200px', marginTop: '0px' },
      textStyle: { marginLeft: '120px' },
      textWeight: 'normal',
      textColor: 'white',
      textWidth: '200px',
      textAlign: 'end'
    }}
    linkTo="/tina"
  />
);

// ÉVEIL
export const EveilWrapper = () => (
  <ProjectWrapper
    wrapperClass="wrapper8"
    position={{ left: 3079, top: 120, zIndex: 'auto' }}
    dimensions={{ width: 643.63, height: 477.31 }}
    hoverConfig={{
      image1: '/media/MinEveilOne.png',
      image2: '/media/MinEveilTwo.png',
      displacementImage: '/media/2.png',
      intensity: 0.35
    }}
    textConfig={{
      title: 'ÉVEIL',
      texts: [
        'Captation, performance',
        '2018 - 2022'
      ],
      blocClass: 'text-bloc-eveil',
      titleClass: 'title-eveil',
      textClass: 'text-eveil',
      blocStyle: { marginTop: '0px', marginLeft: '0' },
      titleStyle: { marginBottom: '20px', marginLeft: '400px', marginTop: '0px' },
      textStyle: { marginLeft: '0px' },
      textWeight: 'bold',
      textColor: 'black',
      textWidth: '200px'
    }}
    linkTo="/eveil"
  />
);